import React, { useState } from 'react';
import { Plus, X, Calendar, Users, MapPin } from 'lucide-react';

export const FloatingActionButton = ({ 
  onCreateLesson, 
  onCreateAthlete, 
  onCreateVenue,
  hidden = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // 🔴 SE NASCOSTO, NON RENDERIZZARE NULLA
  if (hidden) return null;

  const menuItems = [
    { 
      label: 'Inserisci Lezione', 
      icon: Calendar, 
      onClick: onCreateLesson,
    },
    { 
      label: 'Inserisci Atleta', 
      icon: Users, 
      onClick: onCreateAthlete,
    },
    { 
      label: 'Inserisci Struttura', 
      icon: MapPin, 
      onClick: onCreateVenue,
    },
  ];

  const handleItemClick = (action) => {
    setIsOpen(false);
    action();
  };

  return (
    <>
      {/* Overlay scuro quando il menu è aperto */}
      {isOpen && (
        <div 
          className="md:hidden fab-overlay fixed inset-0 bg-black/60 backdrop-blur-sm z-[30] transition-opacity duration-200"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Container FAB - visibile solo su mobile */}
      <div className={`md:hidden fab-container fixed left-1/2 -translate-x-1/2 fab-offset transition-all duration-300 ${isOpen ? 'z-[40]' : 'z-[30]'}`}>
        {/* FAB principale */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`
            w-14 h-14 rounded-full shadow-lg
            flex items-center justify-center
            transition-all duration-300 ease-out
            relative
            ${isOpen ? 'z-0' : 'z-10'}
            ${isOpen 
              ? 'bg-zinc-700 rotate-45' 
              : 'bg-[#ccff00] shadow-[0_0_20px_rgba(204,255,0,0.4)] hover:shadow-[0_0_30px_rgba(204,255,0,0.6)]'
            }
          `}
          data-testid="fab-button"
        >
          {isOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : (
            <Plus className="w-7 h-7 text-black stroke-[3]" />
          )}
        </button>
        {/* Menu Items */}
        <div
          className={`
            absolute bottom-16 left-1/2 -translate-x-1/2
            flex flex-col gap-3 items-center
            transition-all duration-300 ease-out
            ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}
          `}
        >
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={item.label}
                onClick={() => handleItemClick(item.onClick)}
                className="
                  flex items-center justify-center gap-3
                  w-48 px-4 py-3 rounded-full shadow-lg
                  bg-[#ccff00] text-black font-semibold
                  transform transition-all duration-200
                  hover:bg-[#b3e600] active:scale-95
                  animate-fade-in
                "
                style={{ 
                  animationDelay: `${index * 50}ms`,
                  animationFillMode: 'both'
                }}
                data-testid={`fab-menu-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <Icon className="w-5 h-5" />
                <span className="text-sm">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Animazioni */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(10px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.2s ease-out;
        }
      `}</style>
    </>
  );
};
